import { type FC } from "react";
import { MiModal } from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_VARIANTS,
  TYPOGRAPHY_VARIANTS,
} from "@miplatform/constants";
import { mdiCancel } from "@mdi/js";
import { Typography, useTheme } from "@mui/material";

export type CloseAssignableUserColumnModalProps = {
  open: boolean;
  stagedCount: number;
  onClose: () => void;
  onConfirmClose: () => void;
  isLoading?: boolean;
};

export const CloseAssignableUserColumnModal: FC<
  CloseAssignableUserColumnModalProps
> = ({ open, stagedCount, onClose, onConfirmClose, isLoading = false }) => {
  const theme = useTheme();

  return (
    <MiModal
      open={open}
      closeModal={onClose}
      width={330}
      titleIcon={mdiCancel}
      leftIconColor={theme.palette.red.main}
      title="Close assignable user"
      loading={isLoading}
      actions={[
        {
          name: "Keep open",
          variant: BUTTON_VARIANTS.TEXT,
          color: BUTTON_COLORS.BLACK,
          onClick: onClose,
        },
        {
          name: "Close and cancel",
          color: BUTTON_COLORS.RED,
          variant: BUTTON_VARIANTS.CONTAINED,
          disabled: isLoading || stagedCount < 1,
          onClick: onConfirmClose,
        },
      ]}
    >
      <Typography
        variant={TYPOGRAPHY_VARIANTS.SUBTITLE2}
        color="grey"
        mb={2}
        px={2}
      >
        Are you sure you want to close this assignable user column? This will
        cancel all staged assignments for this user.
      </Typography>
    </MiModal>
  );
};
